var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.74632 11.8213H12.7786C12.8479 11.8213 13.0083 11.9526 13.0484 12.0145C13.2343 12.2916 13.063 12.6343 12.7494 12.6963L1.1484 12.6744C1.00622 12.6052 0.871322 12.4703 0.867676 12.2989V0.814537C0.929655 0.43537 1.44007 0.296829 1.65882 0.628599C1.87757 0.96037 1.74632 0.803599 1.74632 0.814537V11.8213Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5964 3.29607C13.0157 3.2268 13.2709 3.68617 13.012 4.0143L8.10108 8.91794C7.94431 8.99815 7.75472 9.01273 7.61254 8.89607L5.64379 6.76326L3.30316 8.90701C2.88389 9.18044 2.399 8.65544 2.71618 8.26534C3.56566 7.51794 4.36045 6.69398 5.21722 5.95388C5.7984 5.45184 5.67295 5.56378 5.99743 5.82992L7.88233 7.90805L12.4068 3.38357C12.4542 3.33982 12.5271 3.30701 12.5927 3.29607H12.5964Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineIcon);
export default __webpack_public_path__ + "static/media/lineIcon.8d563b23c382c2f354c4837a9b6a3101.svg";
export { ForwardRef as ReactComponent };